import * as React from 'react'
// import ReactSVG from 'react-svg'

import Collapse from '@material-ui/core/Collapse'
import classnames from 'classnames'
import { IFAQSection } from '../interfaces'
import styles from './style.module.scss'

interface IReduxStateProps {}
interface IReduxDispatchProps {}
interface IReduxProps extends IReduxStateProps, IReduxDispatchProps {}
interface IProps extends IReduxProps {
  section: IFAQSection
  isMobile: boolean
}

export const Section: React.FC<IProps> = ({ section, isMobile }) => {
  const [isExpanded, setIsExpanded] = React.useState(false)
  const getIsExpanded = () => !isMobile || isExpanded

  return (
    <div className={styles.faq}>
      <div
        className={styles.faq__header}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <h3
          className={classnames(styles.title, {
            [styles['title_arrow-bottom']]: !getIsExpanded()
          })}
        >
          {section.name}
        </h3>
      </div>
      <Collapse
        in={getIsExpanded()}
        className={styles.faq__collapse}
        timeout={150}
      >
        <div className={styles.faq__content}>
          <ul className={styles['faq-content']}>
            {section.items.map((item, i) => (
              <li
                className={classnames(styles['faq-content__item'], {
                  [styles['faq-content__item_tick-icon']]: item.tickIcon
                })}
                key={i}
              >
                <p
                  className={classnames(styles.text, {
                    [styles['text_tick-icon']]: item.tickIcon
                  })}
                >
                  {item.name}
                </p>
              </li>
            ))}
          </ul>
        </div>
        {section.notices && (
          <div className={styles.faq__notices}>
            <ul className={styles['faq-notices']}>
              {section.notices.map((notice, i) => (
                <li className={styles['faq-notices__item']} key={i}>
                  <p className={styles.notice}>{notice}</p>
                </li>
              ))}
            </ul>
          </div>
        )}
      </Collapse>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/pages/Payment/FAQ/Section/index.tsx